import React, { Component } from 'react';
import API from '../services/api';
import './Steps.css';

class EmailActivation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: 'Checking...',
      userId: 0,
      password:'',
      password2:'',
    }
  }

  componentDidMount() {
    (new API()).post('/users/activate',{code: this.props.match.params.code})
      .then(response => {
        this.setState({
          message: response.message,
          userId: response.userId,
        });
      });
  }

  handleFieldChange(e, name) {

    let newState = this.state;
    newState[name] = e.target.value;

    this.setState(newState);
  }

  render() {
    if(this.state.userId) {
      setTimeout(() => {
        window.location = '/login';
      }, 5000);
    }
    return (
      <div className="container">
        <form>
          <div className="Step Step-container active">
            <div className="Step-title">
              {this.state.message}
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default EmailActivation;


// WEBPACK FOOTER //
// ./src/components/EmailActivation.js